import { useState } from "react";

import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKButton from "components/MKButton";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import CircularProgress from "@mui/material/CircularProgress";

import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { postApiData } from "../../redux/actions/SignInAction";
import {
  signInRequested,
  signInRequestFailed,
  resetAuthenticationState,
} from "../../redux/slices/signinSlice";
import bgImage from "assets/images/StartingmyFoundeverLife.jpg";
import { useKeycloak } from "../../Keycloak/KeycloakContext";

function SignInBasic() {
  const { userInfo } = useKeycloak();
  const [loginUser, setLoginUser] = useState("");
  const [token, setToken] = useState("");

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const signInData = useSelector((state) => state.signIn);
  const isAuthenticated = signInData.isAuthenticated;
  const failed = signInData.failed;
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const showModal = (message) => {
    setModalMessage(message);
    setOpenModal(true);
  };

  const handleSignIn = async () => {
    setLoading(false);
    try {
      dispatch(postApiData(loginUser, token));
    } catch (error) {
      dispatch(signInRequestFailed(error.message));
    } finally {
      setLoading(true);
    }
  };

  useEffect(() => {
    if (userInfo && userInfo.username) {
      setLoginUser(userInfo.username);
      setToken(userInfo.token);
      if (userInfo.username.trim().length > 0 && userInfo.token !== "") {
        setLoading(false);
        try {
          dispatch(postApiData(userInfo.username, userInfo.token));
        } catch (error) {
          dispatch(signInRequestFailed(error.message));
        } finally {
          setLoading(true);
        }
      }
    }
  }, [userInfo]);

  useEffect(() => {
    if (isAuthenticated === true) {
      // Retrieve user data from localStorage
      const datosRecuperados = JSON.parse(localStorage.getItem("sesion"));

      const paises =
        datosRecuperados?.rols?.map((rol) => rol.country.countryName) || [];

      if (paises.length > 1) {
        navigate("/views/selectCountry");
        return;
      }

      // Save the selected country in localStorage
      localStorage.setItem("selectedCountry", paises);
      // Get the user's country (example: "CR")
      const userCountry =
        datosRecuperados?.rols?.[0]?.country?.countryName || "default";

      let redirectRoute = "/views/home";
      if (userCountry === "Costa Rica") {
        redirectRoute = "/views/countries/cr/home";
      } else if (userCountry === "Mexico") {
        redirectRoute = "/views/countries/mx/home";
      } else if (userCountry === "Peru") {
        redirectRoute = "/views/countries/pe/home";
      } else if (userCountry === "Colombia") {
        redirectRoute = "/views/countries/pe/home";
      }

      window.location.href = redirectRoute;
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    if (failed === true) {
      showModal("Invalid credentials!!");
      dispatch(resetAuthenticationState());
    }
  }, [failed, navigate, dispatch]);

  useEffect(() => {
    dispatch(signInRequested());
  }, [dispatch]);

  const buttonStyle = {
    background: "#4b4bf9",
    color: "#fff",
  };

  return (
    <>
      <MKBox
        position="absolute"
        top={0}
        left={0}
        zIndex={1}
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({
            functions: { linearGradient, rgba },
            palette: { gradients },
          }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <MKBox
        px={1}
        width="100%"
        height="100vh"
        mx="auto"
        position="relative"
        zIndex={2}
      >
        <Grid
          container
          spacing={1}
          justifyContent="center"
          alignItems="center"
          height="100%"
        >
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            <Card>
              <MKBox
                style={buttonStyle}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                mx={2}
                mt={-3}
                p={2}
                mb={1}
                textAlign="center"
              >
                <MKTypography
                  variant="h4"
                  fontWeight="medium"
                  color="white"
                  mt={1}
                >
                  Bring a Friend
                </MKTypography>
              </MKBox>
              <MKBox pt={4} pb={3} px={3}>
                <MKBox component="form" role="form">
                  <MKBox mb={2}>
                    <MKTypography variant="span" mt={1}>
                      Please click on the Enter button to load your employee
                      info
                    </MKTypography>
                  </MKBox>
                  <MKBox mt={4} mb={1}>
                    <MKButton
                      style={buttonStyle}
                      variant="gradient"
                      color="warning"
                      fullWidth
                      onClick={handleSignIn}
                      disabled={loading}
                      startIcon={
                        loading && (
                          <CircularProgress size={20} color="inherit" />
                        )
                      }
                    >
                      {loading ? "Loading..." : "Load Data"}
                    </MKButton>
                  </MKBox>
                </MKBox>
              </MKBox>
            </Card>
          </Grid>
        </Grid>
      </MKBox>
      <Modal open={openModal} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "400px",
            bgcolor: "background.paper",
            borderRadius: "8px",
            boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.2)",
            p: 3,
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: "3rem", // Ajusta el tamaño aquí
              color: "red",
              marginBottom: "-10px",
            }}
          >
            <ErrorOutlineIcon />
          </div>
          <Typography
            sx={{
              fontSize: "1rem",
              mb: 2,
              color: "text.secondary",
            }}
          >
            {modalMessage}
          </Typography>
          <Button
            style={buttonStyle}
            onClick={handleCloseModal}
            sx={{
              backgroundColor: "error.main",
              color: "background.paper",
              "&:hover": {
                backgroundColor: "error.dark",
              },
            }}
          >
            OK
          </Button>
        </Box>
      </Modal>
    </>
  );
}

export default SignInBasic;
